import { render } from "./Empresas.vue?vue&type=template&id=44694bf7"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"

import "./Empresas.vue?vue&type=style&index=0&id=44694bf7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__